import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews, IconArrowHead } from '../../components';

import css from './ListingPage.module.css';

const SectionPlaceReviews = props => {
  const { publicData, placeReviews, fetchPlaceReviewsError } = props;
  const { googleReviews = {} } = publicData;
  const { enableGoogleReviews = false } = googleReviews;

  if (!enableGoogleReviews || placeReviews.length === 0) {
    return null;
  }

  const [showSection, setShowSection] = useState(true);

  return (
    <section className={css.section}>
      <Heading as="h2" rootClassName={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        <FormattedMessage id="ListingPage.placeReviewsTitle" />
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </Heading>

      {fetchPlaceReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}

      {showSection && (
        <Reviews reviews={placeReviews.reviews} isPlaceReview={true} />
      )}
    </section>
  );
};

export default SectionPlaceReviews;
